module.exports = __webpack_public_path__ + "static/media/mukuaihua_03.458442b1.png";